import { render, staticRenderFns } from "./StoryBackgroundForImage.vue?vue&type=template&id=7e6603c9&scoped=true"
import script from "./StoryBackgroundForImage.vue?vue&type=script&lang=js"
export * from "./StoryBackgroundForImage.vue?vue&type=script&lang=js"
import style0 from "./StoryBackgroundForImage.vue?vue&type=style&index=0&id=7e6603c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6603c9",
  null
  
)

export default component.exports